export default __webpack_public_path__ + "static/media/DodgeLanding.60ff73c2.png";